import { Entity } from '@backstage/catalog-model';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { Card } from '@material-ui/core';
import React from 'react';

interface GraphCardProps {
  height?: number;
  isDefault: boolean;
}

const GraphCard = ({ height, isDefault }: GraphCardProps) => {
  return (
    <Card>
      {isDefault ? (
        <EntityCatalogGraphCard title="" height={height} />
      ) : (
        <EntityCatalogGraphCard
          title=""
          maxDepth={3}
          height={height}
          relations={[
            'childOf',
            'parentOf',
            'hasMember',
            'ownerOf',
            'contributesTo',
          ]}
          entityFilter={(entity: Entity) => {
            if (entity.kind === 'Group') {
              return (
                ![
                  'dh_domain_techcop',
                  'dh_digitalhangarpeopleappgroups',
                ].includes(entity.metadata.name.toLowerCase()) &&
                !entity.metadata.name.toLowerCase().endsWith('contributors')
              );
            }

            if (entity.kind === 'System') {
              return true;
            }
            return false;
          }}
        />
      )}
    </Card>
  );
};

export { GraphCard };
